import FlashLib from 'flashlib_onlyplay';
import maskUtils from '../../utils/masks';
import { gsap } from 'gsap/all';
import SoundManager from 'Engine/soundManager/SoundManager';
import { eSounds } from '../../enums/eSounds';

export default class BasePopup extends FlashLib.MovieClip {
  constructor(data, displayData) {
    super(data, displayData);
    this.alpha = 0;
    this.visible = false;
    this._maskUpdated = false;
    this._idleDuration = 5000;
    this._maskAppearenceDuration = 1000;

    this.addListeners();
    this._idle = this._idle.bind(this);
    this._updateMask = this._updateMask.bind(this);
  }

  init() {
    this.bgAnimation = this.getChildByName('bgAnimation');
    this.wrapper = this.getChildByName('wrapper');
    this.background = this.getChildByName('background');
  }

  addListeners() {
    window.OPWrapperService.eventManager.add(
      window.OPWrapperService.eventManager.types.EET_SCALE_MANAGER_RESIZE,
      this.onGameResized,
      this
    );
  }

  onGameResized(data) {
    if (data.isLandscape) {
      // this.wrapper.scale.set(this.wrapper.displayData.scaleX);
      // this.wrapper.anchorDefault();
      if (this.background) this.background.goToFrame(2);
    } else if (data.isMobile && data.isPortrait) {
      // this.wrapper.scale.set(0.7);
      if (this.background) this.background.goToFrame(1);
    }
  }

  show(delay) {
    setTimeout(() => {
      this.visible = true;
      this.stopMainBackgroundSound();
      if (this.bgAnimation) {
        this.bgAnimation.start();
      }
      this.onShowStart();
      gsap.to(this, { alpha: 1, duration: 0.6, onComplete: () => this.onShow() })
    }, delay);
  }

  hide() {
    gsap.to(this, {
      alpha: 0, duration: 0.3, onComplete: () => {
        this.visible = false;
        if (this.bgAnimation) {
          this.bgAnimation.stop();
        }
        this.onHide();
      }
    });
    this.playMainBackgroundSound();
  }

  onShowStart() {

  }

  onShow() {

  }

  onHide() {
    if (this.maskedEl) {
      maskUtils.updateRectMaskByWidth(this.maskedEl, 0);
    }
  }

  startMaskUpdate(el, duration) {
    this.maskedEl = el;
    this._maskAppearenceDuration = duration || this._maskAppearenceDuration;
    this._maskUpdated = false;
    requestAnimationFrame(this._updateMask);
  }

  startIdle() {
    requestAnimationFrame(this._idle);
  }

  _idle(timestamp) {
    if (!this._startIdleTime) this._startIdleTime = timestamp;
    const diff = timestamp - this._startIdleTime;

    if (diff >= this._idleDuration) {
      this._startIdleTime = null;
      this.hide();
      return;
    }

    requestAnimationFrame(this._idle);
  }

  createMask(el) {
    maskUtils.createRectMask(el);
  }

  _updateMask(timestamp) {
    if (this._maskUpdated) return;

    if (!this._startMaskUpdateTime) this._startMaskUpdateTime = timestamp;
    const diff = timestamp - this._startMaskUpdateTime;

    if (diff >= this._maskAppearenceDuration) {
      this._startMaskUpdateTime = null;
      this._maskUpdated = true;
      maskUtils.updateRectMaskByWidth(this.maskedEl, 100);
      return;
    }

    const progress = diff / this._maskAppearenceDuration * 100;
    maskUtils.updateRectMaskByWidth(this.maskedEl, progress);
    requestAnimationFrame(this._updateMask);
  }

  stopMainBackgroundSound() {
    const backgroundMainGameSound = SoundManager.getSound(eSounds.EST_BACKGROUND.soundName);
    const tween = gsap.timeline();
    tween
      .to(backgroundMainGameSound, { volume: 0, duration: 0.5 })
      .call(() => {
        SoundManager.pause(eSounds.EST_BACKGROUND.soundName)
      })
  }

  playMainBackgroundSound() {
    const backgroundMainGameSound = SoundManager.getSound(eSounds.EST_BACKGROUND.soundName);
    const tween = gsap.timeline();
    tween
      .call(() => {
        SoundManager.play(eSounds.EST_BACKGROUND.soundName, eSounds.EST_BACKGROUND.volume, true, eSounds.EST_BACKGROUND.group);
      })
      .fromTo(backgroundMainGameSound, { volume: 0 }, { volume: eSounds.EST_BACKGROUND.volume, duration: 1.5 })
  }
}
